<template>
    <customModal :containerxxl="true" @closeModal="closeModal">
        <!-- Mitigation List -->
        <template #title> Mitigation Details </template>
        <template #body>
            <div class="modal-scroll-body">
                <!-- Loading -->
                <div class="d-flex justify-content-center align-items-center py-5" v-if="loading">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>

                <!-- No Data -->
                <div class="text-center py-5" v-else-if="!mitigationList.length">
                    <p class="text-muted">No mitigation data available</p>
                </div>

                <!-- Table Content -->
                <div v-else>
                    <div class="table-responsive" style="overflow-x: auto;">
                       <div class="ibox-title style_2 d-flex justify-content-between">
                            <h5 class="mb-0">{{ $t("navigations.mitigations") }}</h5>
                            <div class="position-relative align-self-center mt-0">
                                <img src="@/assets/img/create.png" width="17" alt="Add Arm" style="cursor: pointer;"
                                    @click="openManageMitigationModal()" />
                                <div class="tool-tip">Add Mitigation</div>
                            </div>
                        </div>

                        <table class="table table-striped table-bordered dataTables">
                            <thead>
                                <tr>
                                    <th>CTQ ID</th>
                                    <th>Mitigation ID</th>
                                    <th>Risk Description</th>
                                    <th>Mitigation Strategy</th>
                                    <th>Monitoring Frequency</th>
                                    <th>Action Owner</th>
                                    <th class="text-center" width="80">Edit</th>
                                    <th class="text-center">Tasks</th>
                                    <th class="text-center">View</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="item in mitigationList" :key="item.id">
                                    <td>{{ item.ctqId }}</td>
                                    <td>{{ item.mitigationId }} </td>
                                    <td class="description-cell">
                                        <div>
                                            <span>{{ item.expanded ? item.riskDescription :
                                                truncate(item.riskDescription) }}</span>
                                            <a v-if="item.riskDescription && item.riskDescription.length > 120"
                                                class="more-less-link ms-1" @click.stop="toggleExpand(item)">
                                                {{ item.expanded ? 'less' : 'more' }}
                                            </a>
                                        </div>
                                    </td>

                                    <!-- Mitigation Strategy -->
                                    <td class="description-cell">
                                        <div>
                                            <span>{{ item.expanded ? item.mitigationStrategy :
                                                truncate(item.mitigationStrategy) }}</span>
                                            <a v-if="item.mitigationStrategy && item.mitigationStrategy.length > 120"
                                                class="more-less-link ms-1" @click.stop="toggleExpand(item)">
                                                {{ item.expanded ? 'less' : 'more' }}
                                            </a>
                                        </div>
                                    </td>
                                    <td>{{ item.monitoringFrequency }}</td>
        
                                    <td>{{ item.actionOwner }}</td>
                                    <td class="text-center">
                                            <i class="fa fa-edit edit-delete" title="Edit Mitigation"
                                                @click="openManageMitigationModal(item)"></i>
                                        </td>

                                    <td class="text-center">
                                        <i class="fa fa-eye edit-delete" title="View Tasks" @click="viewTasks(item)">
                                        </i>
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-eye edit-delete" title="View Mitigation"
                                            @click="viewMitigationDetails(item)"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Pagination -->
                    <div class="row mx-0 mt-3" v-if="totalPages > 1">
                        <div class="col-12 d-flex justify-content-end">
                            <VPagination v-model="currentPage" :pages="totalPages" :range-size="1"
                                active-color="#618bd7" @update:modelValue="loadPage" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </customModal>

    <MitigationTasksModal
        v-if="showTasksModal" 
        :data="selectedMitigation" 
        @closeModal="closeTasksModal" 
    />
    <MitigationDetailsModal
        v-if="showMitigationDetailsModal"
        :data="selectedMitigationForDetails"
        @closeModal="closeMitigationDetailsModal"
    />

<ManageMitigationModal
    v-if="showManageMitigationModal"
    :mitigationItem="selectedMitigationForEdit"
    :kriId="data && data.kriId ? data.kriId : ''"
    :ctqId="data && data.ctqId ? data.ctqId : ''"
    :ctqFactor="data && data.ctqFactor ? data.ctqFactor : ''"
    :riskId="data && data.riskId ? data.riskId : ''"
    :fromPage="fromPage"
    @closeModal="closeManageMitigationModal"
    @refreshData="fetchMitigationDetails"
/>

</template>

<script src="./Mitigationinfomodal.js"></script>

<style scoped>
.modal-scroll-body {
    padding: 10px 0;
}

.badge {
    padding: 2px 12px;
    border-radius: 4px;
    font-size: 0.70rem;
    font-weight: 500;
    display: inline-block;
    white-space: nowrap;
}

.badge-success {
    background-color: #d4edda;
    color: #155724;
}

.badge-info {
    background-color: #d1ecf1;
    color: #0c5460;
}

.badge-warning {
    background-color: #fff3cd;
    color: #856404;
}

.badge-danger {
    background-color: #f8d7da;
    color: #721c24;
}

.badge-secondary {
    background-color: #e2e3e5;
    color: #383d41;
}

.badge-light {
    background-color: #f8f9fa;
    color: #212529;
    border: 1px solid #dee2e6;
}

.table th:last-child,
.table td:last-child {
    position: sticky;
    right: 0;
    z-index: 3;
    background: #fff;
    width: 60px;
    min-width: 60px;
}

.table thead th:last-child {
    background: #1a6aa2;
    z-index: 4;
}

.description-cell {
    max-width: 280px;
    white-space: normal;
    word-break: break-word;
}

.more-less-link {
    color: #5b9bd5 !important;
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 600;
    white-space: nowrap;
    user-select: none;
    text-decoration: none;
}

.more-less-link:hover {
    text-decoration: underline !important;
}
.position-relative .tool-tip{
  right: 18px;
  top: 0px;
}
</style>